//
// Module for the Flat Rate Tables Edit view
//
rs.module("content/system_/configuration/flatratetables/edit",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl, columnIds, lrsGridApi) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var addTableDetailButton = criteria.js(jsSelectors.addTableDetailButton, { required: false });
            var detailUpdateToken = criteria.js(jsSelectors.detailUpdateToken, { required: false });
            var flatRateTableDetailKey = criteria.js(jsSelectors.flatRateTableDetailKey, { required: false });
            var flatRateTableDetailFlatAmountInput = criteria.js(jsSelectors.flatRateTableDetailFlatAmountInput, { required: false });
            var flatRateTableDetailReportingFrequencySelect = criteria.js(jsSelectors.flatRateTableDetailReportingFrequencySelect, { required: false });
            var cancelTableDetailButton = criteria.js(jsSelectors.cancelTableDetailButton, { required: false });

            // Build select helper(s) for help with drop downs.
            var flatRateTableDetailReportingFrequencySelectHelper = selectHelper.getHelper(flatRateTableDetailReportingFrequencySelect);

            if (lrsGridApi) {

                // On load, if a row is selected - scroll to ensure it is visible.
                if (lrsGridApi.agGridApi.getSelectedNodes().length != 0) {
                    var firstSelectedRowIndex = lrsGridApi.agGridApi.getSelectedNodes()[0].rowIndex;
                    lrsGridApi.agGridApi.ensureIndexVisible(firstSelectedRowIndex, 'middle');
                }

                // On add button click, clear the form
                addTableDetailButton.click(function () {

                    eventBanner.removeAllMessages();
                    lrsGridApi.selectedValues = null;

                    // Reset inputs
                    [
                        detailUpdateToken,
                        flatRateTableDetailKey,
                        flatRateTableDetailFlatAmountInput
                    ].forEach((input) => input.clearErrors().val(''));
                    flatRateTableDetailKey.val(-1);

                    flatRateTableDetailReportingFrequencySelect.clearErrors();
                    flatRateTableDetailReportingFrequencySelectHelper.setValue('');
                });

                // On cancel button click, select first entry and clear event banner.
                cancelTableDetailButton.click(function () {

                    // Reset inputs
                    [
                        detailUpdateToken,
                        flatRateTableDetailKey,
                        flatRateTableDetailFlatAmountInput
                    ].forEach((input) => input.clearErrors().val(''));
                    flatRateTableDetailKey.val(-1);

                    flatRateTableDetailReportingFrequencySelect.clearErrors();
                    flatRateTableDetailReportingFrequencySelectHelper.setValue('');

                    lrsGridApi.selectedValues = null;
                    lrsGridApi.selectFirstRow();
                    eventBanner.removeAllMessages();
                });

                // Listen for row selection 
                lrsGridApi.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {

                        $.getJSON(backendUrl, { flatRateTableDetailKey: rows[0][columnIds.flatRateDetailKey] }).done(function (data) {

                            // Hidden Fields
                            detailUpdateToken.val(data.updateToken);
                            flatRateTableDetailKey.val(data.flatRateTableDetailKey);

                            // Update Fields
                            flatRateTableDetailFlatAmountInput.val(data.flatAmount);
                            flatRateTableDetailReportingFrequencySelectHelper.setValue(data.reportingFrequency);

                            [
                                flatRateTableDetailFlatAmountInput,
                                flatRateTableDetailReportingFrequencySelect
                            ].forEach((input) => input.clearErrors());
                            eventBanner.removeAllMessages();   
                        });
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);